import { Aggregator, Column } from 'angular-slickgrid';
import { AggregatorTotalsHandler } from 'src/app/types/@types/sl-v-types';
import { SLAggregator } from './slaggregator';
import { ColumnFormatter } from '../formatters/columnformatter';

export class AvgAggregator extends SLAggregator {
	private _count: number;
	protected _name = 'avg';
	protected _label = 'Avg';
	constructor() {
		super();
	}
	init() {
		super.init();
		this._value = {};
	}
	Accumulate(item: any, column: Column<any>) {
		if (this._value[column.id] === undefined) {
			this._value[column.id] = { count: 1, value: Number(item[column.id]) };
		} else {
			const count = this._value[column.id].count + 1;
			const value = this._value[column.id].value + Number(item[column.id]);
			this._value[column.id] = {
				count: (count), value: (value)
			}
		}
	}
	SetTotals(totals: any, completeHandler?: AggregatorTotalsHandler) {
		for (const column of this._columns) {
			if (this._count === 0) {
				this._value[column.id].value = 0;
			} else {
				this._value[column.id].value = this._value[column.id].value / this._value[column.id].count;
			}
		}
		this.SetAltTotals(totals, (columnId)=>{
			return this._value[columnId].value;
		});
		this.EndAggregation(totals, completeHandler);

	}
}